import React from "react";
// External dependencies
import { useSelector } from "react-redux";
import axios from "axios";
//Internal dependencies
import { handleDropdownClick } from "../../../utils/functions/handleDropdownClick";
// CSS Files
import "./userMenuDropDown.css";
import { v2ReactURL } from "../../../utils/constant";

const UserMenuDropDown = ({ wrapperActive, setDropdownState }) => {
  const sessionScope = useSelector((state) => state.sessionData.sessionScope);
  const logoutFunc = () => {
    axios
      .post(`${v2ReactURL}/logout`)
      .then((result) => {
        if (result?.status === 200) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.error("result", err);
      });
  };
  return (
    <>
    {wrapperActive&&<div
          className="header-overlay"
          onClick={() =>
            handleDropdownClick("", setDropdownState)
          }
          onContextMenu={() =>
            handleDropdownClick("", setDropdownState)
          }
        ></div>}
  
    <li
      className="m-nav__item m-topbar__user-profile  m-dropdown m-dropdown--medium m-dropdown--arrow  m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
      m-dropdown-toggle="click"
      onClick={() => handleDropdownClick("wrapperActive", setDropdownState)}
    >
      <a href="#" className="m-nav__link m-dropdown__toggle">
        <span className="m-topbar__userpic">
          <span className="m-type m--bg-brand">
            <span className="m--font-light">{sessionScope.HeaderName}</span>
          </span>
        </span>
        <span className="m-nav__link-icon m-topbar__usericon  m--hide">
          <span className="m-nav__link-icon-wrapper">
            <i className="flaticon-user-ok"></i>
          </span>
        </span>
        <span className="m-topbar__username m--hide">{sessionScope.Name}</span>
        
      </a>
      <div
        className="m-dropdown__wrapper"
        style={{
          display: wrapperActive ? "block" : "none",
        }}
      >
        
        <span className="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
        <div className="m-dropdown__inner">
          <div className="m-dropdown__header card-body-sm">
            <div className="m-card-user m-card-user--skin-light pt-0 pb-0">
              <div className="m-card-user__details pl-0">
                <span className="m-card-user__name m--font-weight-700">
                  {sessionScope.Name}
                </span>
                <span href="" className="m-card-user__email m--font-weight-300">
                  {sessionScope.UserName}
                </span>
              </div>
            </div>
          </div>
          <div className="m-dropdown__body card-body-sm">
            <div className="m-dropdown__content">
              <ul className="m-nav m-nav--skin-light">
                <li className="m-nav__section m--hide">
                  <span className="m-nav__section-text">Section</span>
                </li>
                <li className="m-nav__item">
                  <a href="/setting/general" className="m-nav__link pt-0">
                    <i className="m-nav__link-icon fa fa-user-o"></i>
                    <span className="m-nav__link-text">My Profile</span>
                  </a>
                </li>
                <li className="m-nav__item text-right d-flex">
                  {sessionScope.jioType==0 && <a
                    href="/changepassword"
                    className="btn btn-sm btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder mr-2"
                  >
                    <i className="fa fa-key" aria-hidden="true"></i>
                    Change Password
                  </a>}
                  <button
                    onClick={() => logoutFunc()}
                    className="btn btn-sm btn-danger m-btn m-btn--custom m-btn--label-brand m-btn--bolder"
                  >
                    <i className="fa fa-sign-out" aria-hidden="true"></i>
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </li>
    </>
  );
};

export default UserMenuDropDown;
